import { StateNode } from './StateNode';
export function Machine(config, options) {
    return new StateNode(config, options);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/xstate/es/Machine.js
// module id = 1611
// module chunks = 0